import { FreelancerFeedbackCommonData, FreelancerFeedbackFormModes } from '../../typings/freelancers';

import { AddFreelancerFeedbackStartActionParams } from './freelancer-feedback';

export const CANCEL_FREELANCER_SERVICE_BY_CLIENT_START = 'CANCEL_FREELANCER_SERVICE_BY_CLIENT_START';
export type CANCEL_FREELANCER_SERVICE_BY_CLIENT_START = typeof CANCEL_FREELANCER_SERVICE_BY_CLIENT_START;

export const CANCEL_FREELANCER_SERVICE_BY_CLIENT_SUCCESS = 'CANCEL_FREELANCER_SERVICE_BY_CLIENT_SUCCESS';
export type CANCEL_FREELANCER_SERVICE_BY_CLIENT_SUCCESS = typeof CANCEL_FREELANCER_SERVICE_BY_CLIENT_SUCCESS;

export const CLEAR_FREELANCER_FEEDBACK_FORM = 'CLEAR_FREELANCER_FEEDBACK_FORM';
export type CLEAR_FREELANCER_FEEDBACK_FORM = typeof CLEAR_FREELANCER_FEEDBACK_FORM;

export const CHANGE_FREELANCER_FEEDBACK_FORM_DATA = 'CHANGE_FREELANCER_FEEDBACK_FORM_DATA';
export type CHANGE_FREELANCER_FEEDBACK_FORM_DATA = typeof CHANGE_FREELANCER_FEEDBACK_FORM_DATA;

export const SET_FREELANCER_FEEDBACK_FORM_PENDING = 'SET_FREELANCER_FEEDBACK_FORM_PENDING';
export type SET_FREELANCER_FEEDBACK_FORM_PENDING = typeof SET_FREELANCER_FEEDBACK_FORM_PENDING;

export const OPEN_FREELANCER_FEEDBACK_FORM = 'OPEN_FREELANCER_FEEDBACK_FORM';
export type OPEN_FREELANCER_FEEDBACK_FORM = typeof OPEN_FREELANCER_FEEDBACK_FORM;

export interface CancelFreelancerServiceByClientSuccessActionParams {
    freelancerId: string;
    clientId: string;
    freelancerProject: {
        id: string;
        status: string;
    };
}

export interface CancelFreelancerServiceByClientStartActionParams extends AddFreelancerFeedbackStartActionParams {
    feedbackId?: string;
    projectId: string;
}

export interface OpenFreelancerFeedbackFormParams extends FreelancerFeedbackCommonData {
    feedbackId?: string;
}

export interface CancelFreelancerServiceByClientStartAction {
    type: CANCEL_FREELANCER_SERVICE_BY_CLIENT_START;
    payload: CancelFreelancerServiceByClientStartActionParams;
}

export interface CancelFreelancerServiceByClientSuccessAction {
    type: CANCEL_FREELANCER_SERVICE_BY_CLIENT_SUCCESS;
    payload: CancelFreelancerServiceByClientSuccessActionParams;
}

export interface ClearFreelancerFeedbackFormAction {
    type: CLEAR_FREELANCER_FEEDBACK_FORM;
}

export interface ChangeFreelancerFeedbackFormDataAction {
    type: CHANGE_FREELANCER_FEEDBACK_FORM_DATA;
    payload: FreelancerFeedbackCommonData;
}

export interface SetFreelancerFeedbackFormPendingAction {
    type: SET_FREELANCER_FEEDBACK_FORM_PENDING;
    payload: boolean;
}

export interface OpenFreelancerFeedbackFormAction {
    type: OPEN_FREELANCER_FEEDBACK_FORM;
    mode: FreelancerFeedbackFormModes;
    payload?: OpenFreelancerFeedbackFormParams;
}

export function cancelFreelancerServiceByClientStart(
    payload: CancelFreelancerServiceByClientStartActionParams
): CancelFreelancerServiceByClientStartAction {
    return {
        type: CANCEL_FREELANCER_SERVICE_BY_CLIENT_START,
        payload
    };
}

export function cancelFreelancerServiceByClientSuccess(
    payload: CancelFreelancerServiceByClientSuccessActionParams
): CancelFreelancerServiceByClientSuccessAction {
    return {
        type: CANCEL_FREELANCER_SERVICE_BY_CLIENT_SUCCESS,
        payload
    };
}

export function clearFreelancerFeedbackForm(): ClearFreelancerFeedbackFormAction {
    return {
        type: CLEAR_FREELANCER_FEEDBACK_FORM
    };
}

export function changeFreelancerFeedbackFormData(
    payload: FreelancerFeedbackCommonData
): ChangeFreelancerFeedbackFormDataAction {
    return {
        type: CHANGE_FREELANCER_FEEDBACK_FORM_DATA,
        payload
    };
}

export function lockFreelancerFeedbackForm(): SetFreelancerFeedbackFormPendingAction {
    return {
        type: SET_FREELANCER_FEEDBACK_FORM_PENDING,
        payload: true
    };
}

export function openFreelancerFeedbackForm(
    mode: FreelancerFeedbackFormModes,
    payload: OpenFreelancerFeedbackFormParams
): OpenFreelancerFeedbackFormAction {
    return {
        type: OPEN_FREELANCER_FEEDBACK_FORM,
        mode,
        payload
    };
}

export type FreelancersFeedbackFormAction =
    | CancelFreelancerServiceByClientStartAction
    | CancelFreelancerServiceByClientSuccessAction
    | ClearFreelancerFeedbackFormAction
    | ChangeFreelancerFeedbackFormDataAction
    | SetFreelancerFeedbackFormPendingAction
    | OpenFreelancerFeedbackFormAction;
